import { Inject, Pipe, PipeTransform } from '@angular/core';
import { Environment, ENVIRONMENT_TOKEN } from '../../core/environment.service';

@Pipe({
    name: 'ftAzureImageUrl'
})
export class AzureImageUrlPipe implements PipeTransform {
    origin: string;

    constructor(@Inject(ENVIRONMENT_TOKEN) private environment: Environment) {
        this.origin = environment.AzureCdnBaseUrl + 'public/';
        // this.origin = 'https://cdn.flip.to/' + 'public/'; //@todo remove
    }

    transform(imageId: string, imageSizeType?: string, extension?: string): string {
        if (!imageId) {
            return '';
        }
        return `${this.origin}${imageId.toLowerCase()}${!!imageSizeType ? '-' + imageSizeType.toLowerCase() : ''}.${extension || 'jpg'}`;
    }
}
